import React, { Component } from 'react'
import { Footer, Header } from 'marketing-components'
import serverData from 'utils/server-data'
import { Message, WorldReady } from '@paypalcorp/worldready'

// eslint-disable-next-line camelcase
export default class Layout extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const country = serverData.locality.country
    const directionality = serverData.locality.directionality
    const worldReady = new WorldReady(serverData.locality.locale)
    const message = new Message(worldReady)
    const privacyText = message.format('app.footer.privacy')
    const legalText = message.format('app.footer.legal')
    const feedbackText = message.format('app.footer.feedback')

    let footerNotesText = message.format('app.footer.notes')

    if (footerNotesText === 'app.footer.notes') {
      footerNotesText = ''
    }

    const config = {
      useMinimalHeader: true,
      hideHeaderButtons: true,
      rtl: directionality === 'rtl',
    }
    const footerProps = {
      content: {
        country: {
          locales: [],
          flag: null,
        },
        mainLinks: {},
        secondaryLinks: {},
        copyRight: {},
        tertiaryLinks: {
          list: [
            {
              text: privacyText,
              href: '/webapps/mpp/ua/privacy-full',
            },
            {
              text: legalText,
              href: '/webapps/mpp/ua/legalhub-full',
            },
            {
              text: feedbackText,
              href: '#',
              id: 'siteFeedback',
            },
          ],
        },
        footerNotes: {
          text: footerNotesText,
        },
      },
      localeCountry: `${country}`,
      loggedIn: false,
      flagHref: '',
      rtl: directionality === 'rtl',
    }
    return (
      <div style={{ direction: directionality }}>
        <Header config={config} />
        <div className="template-content">{this.props.children}</div>
        <Footer {...footerProps} />
      </div>
    )
  }
}
